import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from "react";

// Layout
import ProtectedRoute from "./ProtectedRoutes";
import AuthLayout from "../layouts/AuthLayout";
import Loader from "../components/Common/Loader";

// Pages
const LogIn = lazy(() => import("../pages/Authentication/LogIn"));
const LogOut = lazy(() => import("../pages/Authentication/LogOut"));
const NotFound = lazy(() => import("../pages/404"));

// Workplace Check-in
const WorkplaceCheckIn = lazy(() => import("../pages/Pulse/CheckIn"));
const WorkplaceCheckInInsights = lazy(() =>
  import("../pages/Pulse/CheckIn/Insights")
);
const WorkplaceCheckInPillar = lazy(() =>
  import("../pages/Pulse/CheckIn/Pillar")
);
const WorkplaceCheckInQuestions = lazy(() =>
  import("../pages/Pulse/CheckIn/Questions")
);

const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <Routes>
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            {/* workplace check-in */}
            <Route
              path="/dashboard"
              element={<WorkplaceCheckIn />}
            />
            <Route
              path="/insights/monday"
              element={<WorkplaceCheckInInsights type="monday" />}
            />
            <Route
              path="/insights/wednesday"
              element={<WorkplaceCheckInInsights type="wednesday" />}
            />
            <Route
              path="/insights/friday"
              element={<WorkplaceCheckInInsights type="friday" />}
            />
            <Route
              path="/insights/:date/pillar/:pillar"
              element={<WorkplaceCheckInPillar />}
            />
            <Route path="/questions" element={<WorkplaceCheckInQuestions />} />
          </Route>

          {/* Authentication Routes */}
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LogIn />} />
            <Route path="/logout" element={<LogOut />} />
          </Route>

          <Route
            path="/"
            element={<Navigate to="/dashboard" />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default AppRoutes;
